import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import Translate from 'utils/translate';

import { RELEASE } from "utils/environment";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@cloud-one-common/library-ui-components';

const cookies = new Cookies();

export default class Download extends Component {
  constructor() {
    super();
    this.state = {
      confirm: false,
    };
  }

  checkConfirmation(e, src) {
    e.preventDefault();
    if (RELEASE === 'fp' && !cookies.get('accepted-contract')) {
      this.setState({
        confirm: true,
      });
    } else {
      window.location = src;
    }
  }

  confirmDownload(confirm) {
    const { src } = this.props;

    this.setState({
      confirm: false,
    });

    if (confirm) {
      cookies.set('accepted-contract', true);
      window.location = src;
    }
  }

  renderConfirmModal() {
    return (
      <Modal>
        <ModalHeader>
          <Translate stringID="confirm.title" defaultValue="Confirm Title" />
        </ModalHeader>
        <ModalBody>
          <p style={{ textAlign: 'left' }}>
            <Translate stringID="confirm.body" defaultValue="" />
          </p>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.confirmDownload.bind(this, true)} type="PRIMARY">
            <Translate stringID="confirm.download" defaultValue="Download" />
          </Button>
          <Button onClick={this.confirmDownload.bind(this, false)}>
            <Translate stringID="confirm.cancel" defaultValue="Cancel" />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  renderDownloadLink() {
    const { disabled, displayIcon, src, text } = this.props;

    const downloadIcon = <img src={require('images/download.svg')} width={28} height={28} />;

    if (disabled) {
      return text;
    } else {
      return (
        <a href={src} onClick={e => this.checkConfirmation(e, src)}>
          {displayIcon ? downloadIcon : text}
        </a>
      );
    }
  }

  render() {
    const { confirm } = this.state;

    return (
      <span>
        {this.renderDownloadLink()}
        {confirm ? this.renderConfirmModal() : null}
      </span>
    );
  }
}

Download.propTypes = {
  src: PropTypes.string.isRequired,
  displayIcon: PropTypes.bool,
  text: PropTypes.string,
};
